import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '../../auth.service'
import { switchMap, takeUntil } from 'rxjs/operators'
import { from, Subject } from 'rxjs'

@Component({
  selector: 'lib-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false
})
export class LogoutComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void>

  private refineUrl = (url: string | undefined): string =>
    url == null ? null : url.replace('/tracker', '')

  ngOnInit(): void {
    this.authService
      .completeLogout()
      .pipe(
        takeUntil(this.destroyed$),
        switchMap(action => {
          return from(this.router.navigateByUrl(this.refineUrl(action.userState as string)))
        })
      )
      .subscribe()
  }

  ngOnDestroy(): void {
    this.destroyed$.next()
    this.destroyed$.complete()
  }

  constructor(private router: Router, private authService: AuthService) {
    this.destroyed$ = new Subject<void>()
  }
}
